import { parseError } from 'utils/utils';
import apiService from 'services/apiService';
import Module from 'models/Module';

export class ModuleService {
  private static instance: ModuleService;

  public static get(): ModuleService {
    if (!ModuleService.instance) {
      ModuleService.instance = new ModuleService();
    }

    return ModuleService.instance;
  }

  getModule = async (moduleId: string): Promise<Module> => {
    try {
      const response = await apiService.api.get(`/modules/${moduleId}`);
      return response.data;
    } catch (error) {
      console.error(error);
      return Promise.reject(new Error(parseError(error)));
    }
  };

  getModuleAssignments = async (moduleId: string): Promise<Module> => {
    try {
      const response = await apiService.api.get(
        `/modules/${moduleId}/assignments`,
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return Promise.reject(new Error(parseError(error)));
    }
  };

  copyModule = async (moduleId: string, classroomId: string): Promise<void> => {
    try {
      const response = await apiService.api.post(`/modules/${moduleId}/copy/`, {
        classroom: classroomId,
      });
      return response.data;
    } catch (error) {
      console.error(error);
      return Promise.reject(new Error(parseError(error)));
    }
  };

  generateModule = async (formData: Record<string, any>): Promise<void> => {
    try {
      /*
      {
            topic: what is this module about?
            description: module description displayed in the UI to teachers and students
            learner_level: a LearnerLevel
            easy_vocab: important vocab for this module
            hard_vocab: important advanced vocab for this module
            classroom: the ID of the classroom to create this module
        }
      */
      const response = await apiService.api.post(
        `/modules/generate/`,
        formData,
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return Promise.reject(new Error(parseError(error)));
    }
  };
}

export const moduleService = ModuleService.get();
